module.exports = __webpack_public_path__ + "img/midnight-blue.26944bcf.png";